export default "__VITE_ASSET__DE8q37PD__"